module.exports = __webpack_public_path__ + "media/images/dropdown-008f87f4856af5a49d9b553bdfa1d728.png";